import styled, { css } from 'styled-components'
import { rem } from 'utils/common'
import { merchantThemes, device } from 'components/Variable'

export const AlertBottomStyle = styled.div`
	position: absolute;
	bottom: 100%;
	left: 0;
	width: 100%;
	display: flex;
	text-align: center;
	background-color: ${({ theme }) => theme.color.secondary};
	border-top: 1px solid ${({ theme }) => theme.color.grayOne};
	border-bottom: ${rem(2)} solid ${({ theme }) => theme.color.grayOne};
	padding: ${rem(20, 15)};
	justify-content: center;
	transition: transform 0.3s;
	transform: translateY(100%);
	z-index: 0;
	@media (${device.tablet}) {
		padding: ${rem(15, 40, 15, 30)};
	}
	@media (${device.mobileL}) {
		padding: ${rem(15, 30, 15, 15)};
	}
	${(p) =>
		p.alertBottom === 'open' &&
		css`
			z-index: 5;
			transform: translateY(0);
		`}
	${(p) =>
		p.theme.name === merchantThemes.musto &&
		css`
			border-bottom: ${rem(2)} solid
				${({ theme }) => theme.color.tertiary};
		`}
`
export const CloseButton = styled.div`
	position: absolute;
	right: ${rem(36)};
	top: 50%;
	margin-top: -7px;
	cursor: pointer;
	
	@media (${device.tablet}) {
		right: ${rem(15)};
	}
	
	@media (${device.mobileM}) {
		right: ${rem(10)};
	}
	
	&:hover svg {fill: ${({ theme }) => theme.color.primary}
`
export const Content = styled.div`
	font-size: ${rem(16)};
	line-height: ${rem(24)};
	text-align: center;
	letter-spacing: ${rem(0.228571)};
	max-width: ${rem(500)};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-size: ${rem(15)};
			letter-spacing: ${rem(0.06)};
			line-height: ${rem(20)};
		`}

	a {
		color: ${({ theme }) => theme.color.primary};
	}

	@media (${device.mobileM}) {
		font-size: ${rem(13)};
		line-height: ${rem(18)};

		${(p) =>
			p.theme.name === merchantThemes.toteme &&
			css`
				font-size: ${rem(15)};
			`}
	}
`
